import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import QRCode from "qrcode";

const PreviewOtto = ({ show, onHide, content, count = 1, scale }) => {

  // console.log('content ', content)

  const [qrCode, setQrCode] = useState("");

  // ============================================================
  // GENERATE QR CODE
  // ============================================================
  useEffect(() => {
    const generateQR = async () => {
      try {
        // ========================================================
        // QR CODE NOW LINKS TO LERROS CONTACT PAGE
        // Scanning this QR code will open the Lerros HQ contact page
        // ========================================================
        const qrData = "https://company.lerros.com/de/kontakt/zentrale";

        const qr = await QRCode.toDataURL(qrData, {
          width: 150,
          margin: 0,
          errorCorrectionLevel: "M",
        });

        setQrCode(qr);
      } catch (error) {
        console.error("QR Code generation error:", error);
        setQrCode("");
      }
    };

    generateQR();
  }, []);



  const createValidSizeListString = (data) => {
    if (!data?.TotalQtys || !data?.header) return { valid_sizelist: "", valid_sizevalues: "" };

    const sizArr = data.TotalQtys;
    const new_size_list = [];
    const default_size_list = [];

    for (let i = 0; i < 12; i++) {
      if (sizArr[i] !== 0) {
        new_size_list.push(sizArr[i]);
        default_size_list.push(data.header[i]);
      }
    }

    const valid_sizelist = default_size_list.join(" + ");
    const valid_sizevalues = new_size_list.join(" + ") + " = " + sizArr[12];
    return { valid_sizelist, valid_sizevalues };
  };

  // Generate values
  const { valid_sizelist, valid_sizevalues } = createValidSizeListString(content);


  const tbl = `
  <div class="main_container">
    <div class="container">
        <div class="flex-container">
          <div class="flex-container-child">
            <div style="flex-container-child1">
              <h2>CUSTOMER - OTTO</h2>
            </div>
            <div style="flex-container-child1" >
              <h1>PO: ${content?.PO || "PO"}</h1>
              <h1>CTN. NO ${content?.SNO || "SNO"}</h1>
            </div> 
          </div>
          <div>
            <table>
              <tr>         
                <td style="vertical-align: middle; height: 100px;">
                  <div style="white-space: nowrap; font-size: 18px; font-weight: bold; max-width: 50px; height: 100%; display: flex; flex-direction: column; justify-content: center;">
                      Art-Nr:
                          ${content?.DIM?.length > 0
      ? '<br/><span style="font-size: 18px; font-weight: bold; margin-top:21px;">Dim: </span>'
      : ""
    }
                    </div>
                </td>
                  <td style="vertical-align: middle; height: 100px;">
                    <div style="height: 100%; display: flex; flex-direction: column; justify-content: center;">
                      <h2 style="margin: 0;">${content?.ArtNo || "ArtNo"}</h2>
                        <span style="margin : 0px ; font-size: 18px; font-weight: bold;">
                        ${content?.DIM?.length > 0 ? `<br/>${content.DIM}` : ""}
                      </span>
                    </div>
                  </td>

                <td>
                  <div
                    class="cell-flex"
                    style="
                      max-height: 50px;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <div style="font-size: 18px; font-weight: bold">Auftragsnummer</div>
                    <div><h2>${content?.orderNo || "order no"}</h2></div>
                    </div>
                </td>
              </tr>
              <tr>
                <td style=" max-width: 50px; font-size: 18px; font-weight: bold">Größe:</td>
                <td style=" max-width: 150px; text-align:center">
                  <div> 
                    <h3 style= "margin: 0">${valid_sizelist || 0}
                    </h3>
                  </div>
                </td>

                <td rowspan="2">
                  <div
                    class="cell-flex"
                    style="max-width: 150px; align-items: center"
                  >
                    <div style="font-weight: bold; margin-left: 160px">
                      Absender
                    </div>
                    <!-- <div>${content?.Absender || ""}</div> -->
                    <div style="text-align: center">
                    <pre
                    style={{
                      fontWeight: "bold",
                      fontSize: "15px",
                      textAlign: "center",
                      // border: "2px solid green",
                    }}
                  >
                    LERROS Moden GMBH
                    PLANGE MUEHLE 4, D-40221
                    DUESSELDORF, GERMANY
                  </pre>
                  
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="font-size: 18px; font-weight: bold; max-width: 50px;">Menge:</td>
                <td style="max-width: 150px; text-align:center"><h3 style="margin: 0">${valid_sizevalues}pcs</h3></td>
              </tr>
            </table>
          </div>
        </div>
        <div class="qr-main">
        <div class="carton-id">${content?.carton_ID}</div>
                  <img
                    src="${qrCode}"
                    class="qr-code"
                    alt="QR Code"
                  />
               </div>
      </div>
      
      </div>
      `;

  const htmlContent = `<html lang="en">
    <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Complex Table with Flexbox</title>
    <style>
      .main_container{
        // boder: 2px solid red;
      }
      .container {
        // border: 2px solid red !important;
        display: flex;
        jistify-content: space-between;
        align-items: end;
      }
      .heading {
        font-size: 1.5em;
        margin-bottom: 10px;
      }
      .flex-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // border:2px solid red;
        width:100%;
      }
      .flex-container-child{
        // border:2px solid green;
        width:40%
      }
      .flex-container-child1 ,h1, h2{
        // border:2px solid red;
        text-align:center;
      }
      // .flex-container div:first-child {
      //   flex: 1;
      // }
      .flex-container div:last-child {
        flex: 3;
      }
      .flex-container h1 {
        margin: 0;
      }
      .cell-flex {
        display: flex;
        flex-direction: column;
        height: 130px;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;
        height: 300px;
      }
      table,
      th,
      td {
        border: 1px solid #000;
      }
      .common-cell {
        display: flex;
        flex-direction: column;
        text-align: center;
      }
      .barcode-cell {
        padding: 10px;
        width: 100%;
        height: 220px;
      }
      .hr-style-16-container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 10px 0;
        width: 1150px;
      }

      hr.style-16 {
        flex-grow: 1;
        border: none;
        border-top: 2px dashed black;
      }

      .hr-style-16-container span {
        display: inline-block;
        padding: 0 10px;
        background: #f0f0f0;
        font-size: 18px;
      }

      .qr-main{
      // border: 1px solid red;
      width: 150px;
      display: flex;
      justify-content: end;
      align-items: center;
      flex-direction: column;
      }
      .carton-id{
        padding: 0px 0px 10px 0px;
        font-weight: 500;
      }
    
      .qr-code {
         width: 100px;
         height: 100px;
         display: block;
         object-fit: contain;
        }


      @media print {
        .container {
          page-break-inside: avoid;
        }
        .flex-container {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
        }
      }
    </style>

  </head>
      <body>
        <div class="tables-container">
              ${tbl}
                <div class="hr-style-16-container">
                  <hr class="hr-style-16">
                  <span>&#x2702;</span>
                  <hr class="style-16">
                </div>
              ${tbl}
        </div>
      </body>
  </html>`;
  return (
    // <Modal.Body
    //   style={{
    //     maxHeight: "70vh",
    //     overflow: "auto",
    //     padding: "4px",
    //     backgroundColor: "#f8f9fa",
    //     boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    //     display: "flex",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     paddingTop: "9%",
    //   }}
    // >
    <div
      style={{
        width: "auto",
        height: "auto",
        overflow: "visible",
        // transform: `scale(${scale})`,
        zoom: scale,
        padding: "100px",
        // transformOrigin: "top center",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      dangerouslySetInnerHTML={{
        __html: htmlContent,
      }}
    />
    // </Modal.Body>
  );
};

export default PreviewOtto;
